import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CircleTimer.css';

class CircleTimer extends React.Component {
  static propTypes = {
    time: PropTypes.number, // Time in seconds
    repeat: PropTypes.bool,
    timeUp: PropTypes.func,
  };

  static defaultProps = {
    time: 300,
    repeat: false,
    timeUp: () => {},
  };

  state = {
    formatedTime: '0:00',
    iId: 0,
    time: 0,
  };

  componentDidMount = () => {
    this.setState({
      time: this.props.time,
      formatedTime: this.formatTime(this.props.time),
    });
    this.startTimer();
  };

  componentWillUnmount = () => {
    this.stopTimer();
  };

  formatTime = time => {
    const minutes = Math.floor(time / 60);
    let seconds = time % 60;
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return `${minutes}:${seconds}`;
  };

  startTimer = () => {
    const self = this;
    const { time, repeat, timeUp } = this.props;

    const callCallback = () => {
      setTimeout(timeUp);
    };

    const iId = setInterval(() => {
      if (self.state.time < 1) {
        if (!repeat) {
          try {
            self.stopTimer();
            callCallback();
          } catch (err) {
            console.error(err);
          }
        } else {
          self.state.time = time;
        }
      } else {
        self.state.time -= 1;
      }

      const formatedTime = self.formatTime(self.state.time);
      self.setState({ formatedTime });
    }, 1000);
    self.setState({ iId });
  };

  stopTimer = () => {
    clearInterval(this.state.iId);
  };

  render() {
    const seconds = `${this.props.time}s`;
    const animationFill = this.props.repeat ? 'remove' : 'freeze';
    return (
      <svg
        className="circle-chart"
        viewBox="0 0 110 110"
        width="120"
        height="120"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          fill="rgba(255, 217, 6, 0.2)"
          stroke="rgba(255, 217, 6, 0.2)"
          strokeWidth="2"
          cx="50%"
          cy="50%"
          r="50"
        />
        <circle
          className={s.circleTimerProgress}
          stroke="#FFD906"
          strokeWidth="2"
          strokeDasharray="0,314"
          strokeDashoffset="314"
          strokeLinecap="round"
          fill="none"
          cx="50%"
          cy="50%"
          r="50"
        >
          <animate
            attributeName="stroke-dasharray"
            dur={seconds}
            begin="0"
            values="0,314;314,0"
            fill={animationFill}
          />
        </circle>

        <g>
          <text
            className={s.circleTimerText}
            x="50%"
            y="50%"
            alignmentBaseline="central"
            textAnchor="middle"
          >
            {this.state.formatedTime}
          </text>
        </g>
      </svg>
    );
  }
}

export default withStyles(s)(CircleTimer);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/CircleTimer/CircleTimer.js